import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from '@headlessui/react'
import { X } from 'lucide-react'
import { SidebarContent } from './SidebarContent';
import { SafePaddingContainer } from './SafePaddingContainer';


export function Sidebar({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (open: boolean) => void }) {
  return (
    <Dialog open={isOpen} onClose={setIsOpen} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
      />


      <div className="fixed inset-0 flex">
        <DialogPanel
          transition
          className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
        >
          <TransitionChild>
            <div className="absolute left-full top-0 flex justify-center duration-300 ease-in-out data-[closed]:opacity-0">
              <SafePaddingContainer orientation='vertical-only' className='mt-1 -translate-x-2.5'>
                <button type="button" onClick={() => setIsOpen(false)}>
                  <span className="sr-only">Close sidebar</span>
                  <X className="size-6 ml-6 text-white" />
                </button>
              </ SafePaddingContainer>
            </div>
          </TransitionChild>
          <SidebarContent setIsOpen={setIsOpen}/>
        </DialogPanel>
      </div> 
    </Dialog>
  )
}